import React, {
  ComponentType,
  FC,
  useCallback,
  useRef,
  useEffect,
} from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { FieldType } from 'components/organisms/tasks/fields';
import { EditorPopupParams, EditorPopupsProps } from './with-editor-popups';

const field_types: (string | null)[] = [
  FieldType.Date,
  FieldType.Assignee,
  FieldType.SingleUser,
  FieldType.MultiUser,
  FieldType.SingleSelect,
  FieldType.MultiSelect,
];

const handle = ({ ePopup }: EditorPopupParams): boolean => {
  const wrapper = ePopup.querySelector('[data-field-type]') as HTMLElement;

  if (
    wrapper == null ||
    !field_types.includes(wrapper.getAttribute('data-field-type'))
  ) {
    return false;
  }

  return true;
};

export const withPopoverFieldEditors = <T extends EditorPopupsProps>(
  Component: ComponentType<T>,
): FC<T> => {
  const Next: FC<T> = ({ onPopup: actualOnPopup, ...props }) => {
    const onPopupRef = useRef<Required<EditorPopupsProps>['onPopup'] | null>(
      actualOnPopup ?? null,
    );
    const onPopup = useCallback(
      (params: EditorPopupParams) =>
        onPopupRef.current?.(params) ?? false ? true : handle(params),
      [onPopupRef],
    );

    useEffect(() => {
      onPopupRef.current = actualOnPopup ?? null;
    }, [onPopupRef, actualOnPopup]);

    return <Component {...(props as any)} onPopup={onPopup} />;
  };

  return setDisplayName(wrapDisplayName(Component, 'WithPopoverFieldEditors'))(
    Next,
  );
};
